import { fork } from 'redux-saga/effects'

import errorSaga from './errorSaga'
import respondentSaga from './respondentSaga'
import timerSaga from './timerSaga'
import pagingSaga from './pagingSaga'
import authSaga from './authSaga'
import uxSaga from './uxSaga'
import ormSaga from '../orm/saga'
import concurrencySaga from './concurrencySaga'

export default function* rootSaga() {
  yield fork(respondentSaga)
  yield fork(pagingSaga)
  yield fork(timerSaga)
  yield fork(authSaga)
  yield fork(ormSaga)
  yield fork(errorSaga)
  yield fork(uxSaga)
  yield fork(concurrencySaga)
}
